/**
 * IoType is the definition of io_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum IoType {
  INBOUND = "I",
  OUTBOUND = "O",
  INBOUNDOUTBOUND = "IO",
}
/**
 * EdhPrtclType is the definition of edh_prtcl_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum EdhPrtclType {
  OS = "OS",
  DB = "DB",
  T_ANPLN = "T_ANPLN",
  GCS = "GCS",
  COS = "COS",
  GD = "GD",
  BQ = "BQ",
  PDB = "PDB",
  EXA = "EXA",
  T_GD = "T_GD",
  T_GD_S3 = "T_GD_S3",
  T_S3_DB = "T_S3_DB",
  T_SFTP = "T_SFTP",
  T_WS = "T_WS",
  T_HTTPS = "T_HTTPS",
  T_SOAP = "T_SOAP",
  T_TRT = "T_TRT",
  FCOS = "FCOS",
  MSSP = "MSSP",
}
/**
 * InterfaceStartMethodType is the definition of interface_start_method_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum InterfaceStartMethodType {
  FILE_DRIVEN = "FILE_EVENT",
  EDF_REST = "EDF-REST",
  JP1_JOBLANCHER = "JOB_LAUNCHER",
  CRON = "CRON",
  JOBSTARTER_SDK = "JOB_STARTER",
  NATIVE = "NATIVE",
}
/**
 * ChnTypeType is the definition of chn_type_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum ChnTypeType {
  HTTPS_NOENC_STATUS = "01",
  HTTPS_NOENC_XML = "08",
  HTTPS_ENC_STATUS = "09",
  HTTPS_ENC_XML = "10",
  AS2_OPEN_TEXT = "12",
  ZENGIN_OPEN_TEXT = "30",
  MAIL_SIGN_ENC = "02",
  MAIL_PLAIN = "06",
  MAIL_ZIP = "07",
  S3 = "90",
  COS = "91",
  SFTP_WITH_KEY = "21",
  SFTP_REMOVE_WITH_KEY = "22",
  SFTP_MOVE_WITH_KEY = "23",
  SFTP_WITH_PASSWORD = "24",
  SFTP_REMOVE_WITH_PASSWORD = "25",
  SFTP_MOVE_WITH_PASSWORD = "26",
  SCP_WITH_KEY = "41",
  SCP_WITH_PASS = "42",
  FTP = "20",
}
/**
 * FileTypeType is the definition of file_type_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum FileTypeType {
  COMPLETE_XML = "00",
  XML_CSV = "01",
  XML_CSV_COMBINED = "02",
  XML_CSV_SPLITTED = "03",
  COMPLETE_CSV = "10",
  RAW = "90",
}
/**
 * EdhNotificationType is the definition of edh_notification_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum EdhNotificationType {
  NATIVE = "N",
  RES_TAPI = "R",
  KAFKA = "K",
  SSH = "S",
  DLK = "D",
}
/**
 * BdryType is the definition of bdry_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum BdryType {
  INBOUND = "1",
  OUTBOUND = "2",
}
/**
 * ClodSrvc is the definition of clod_srvc.
 * It is used for the validation comparing with the value from general code master.
 */
export enum ClodSrvc {
  AWS = "AWS",
  TENCENT = "Tencent",
  GCP = "GCP",
}
/**
 * ClodSrvcCntnrType is the definition of clod_srvc_cntnr_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum ClodSrvcCntnrType {
  ECS = "1",
  K8S = "2",
}
/**
 * ClodSrvcRgn is the definition of clod_srvc_rgn.
 * It is used for the validation comparing with the value from general code master.
 */
export enum ClodSrvcRgn {
  TKY = "TKY",
  SGP = "SGP",
  VIR = "VIR",
  FRK = "FRK",
  MUM = "MUM",
  SHA = "SHA",
  MOW = "MOW",
}
/**
 * CpntOwnType is the definition of cpnt_own_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum CpntOwnType {
  APP = "App",
  PF = "PF",
}
/**
 * CpntAlctnType is the definition of cpnt_alctn_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum CpntAlctnType {
  ALL = "1",
  REGION = "2",
  BUSINESS_UNIT = "3",
  GLOBAL_BU_X_COUNTRY = "4",
  GLOBAL_BU_X_REGION = "5",
  COUNTRY = "6",
  OTHER = "7",
}
/**
 * PtnrType is the definition of ptnr_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum PtnrType {
  LOGISTICS = "1",
  SUPPLIER = "2",
  WAREHOUSE = "3",
  EC_WAREHOUSE = "4",
  OTHERS = "5",
}
/**
 * EnvTypeCd is the definition of env_type_cd.
 * It is used for the validation comparing with the value from general code master.
 */
export enum EnvTypeCd {
  STG = "STG",
  OTHER_STG = "OTHER_STG",
  PRD = "PRD",
}
/**
 * PtnrBuCntryType is the definition of ptnr_bu_cntry_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum PtnrBuCntryType {
  BU = "1",
  CN = "2",
}
/**
 * NtcStsType is the definition of ntc_sts_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum NtcStsType {
  UNSENT = "0",
  SUCCEEDED = "1",
  FAILED = "2",
  RETRYING = "3",
}
/**
 * TcktType is the definition of tckt_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktType {
  PROJECT_PLAN = "TASK-PJ-010",
  PROJECT_PROGRESS = "TASK-PJ-020",
  COMPONENT_PROJECT_PROGRESS = "TASK-PJ-030",
  IF_DESIGN = "TASK-IF-010",
  IF_STAGING_DEPLOYMENT = "TASK-IF-020",
  IF_PRODUCTION_DEPLOYMENT = "TASK-IF-030",
  COMPONENT_DESIGN = "TASK-PT-010",
  COMPONENT_STAGING_DEPLOYMENT = "TASK-PT-020",
  COMPONENT_PRODUCTION_DEPLOYMENT = "TASK-PT-030",
  STAGING_COMPONENT_SETUP_TASK = "TASK-PT-040",
  OTHER_STAGING_COMPONENT_SETUP_TASK = "TASK-PT-050",
  PRODUCTION_COMPONENT_SETUP_TASK = "TASK-PT-060",
}
/**
 * TcktStsTypePrjPlan is the definition of tckt_sts_type_prj_plan.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypePrjPlan {
  WAITING_FOR_ASSIGNMENT_REQUIREMENTS_DEFINER = "01",
  ESTIMATION_IN_PROGRESS = "02",
  UNDER_ESTIMATE_CONFIRMATION = "03",
  UNDER_OBTAIN_BUDGET = "04",
  PROJECT_PLANNING_FINAL_CHECK_IN_PROGRESS = "05",
  PROJECT_PLANNED = "06",
}
/**
 * TcktStsTypePrjPrgrs is the definition of tckt_sts_type_prj_prgrs.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypePrjPrgrs {
  WAITING = "01",
  IF_REQUIREMENT_DESIGN = "02",
  ASSIGNING_STAKEHOLDERS = "03",
  PROJECT_IN_PROGRESS = "04",
  CHANGING_IF_REQUIREMENTS = "05",
  PROJECT_COMPLETE = "06",
}
/**
 * TcktStsTypeIfDsgn is the definition of tckt_sts_type_if_dsgn.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeIfDsgn {
  DESIGN = "01",
  DESIGN_REVIEW = "02",
  DESIGN_APPROVED = "03",
  CANCELLED = "04",
}
/**
 * TcktStsTypeIfStgDplymnt is the definition of tckt_sts_type_if_stg_dplymnt.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeIfStgDplymnt {
  WAITING = "01",
  REQUEST_PLANNING = "02",
  DEPLOYMENT_APPROVAL_PENDING = "03",
  DEPLOYMENT_PENDING = "04",
  DEPLOYING = "05",
  WAITING_FOR_RETRY = "06",
  DEPLOYED = "07",
  DEPLOYMENT_FAILED = "08",
  REVERT_DEPLOYMENT_APPROVAL_PENDING = "09",
  REVERT_DEPLOYMENT_PENDING = "10",
  REVERT_DEPLOYING = "11",
  REVERT_WAITING_FOR_RETRY = "12",
  REVERT_DEPLOYMENT_FAILED = "13",
  CANCELLED = "14",
}
/**
 * TcktStsTypeIfPrdDplymnt is the definition of tckt_sts_type_if_prd_dplymnt.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeIfPrdDplymnt {
  WAITING = "01",
  REQUEST_PLANNING = "02",
  DEPLOYMENT_APPROVAL_PENDING = "03",
  DEPLOYMENT_PENDING = "04",
  DEPLOYING = "05",
  WAITING_FOR_RETRY = "06",
  DEPLOYED = "07",
  DEPLOYMENT_FAILED = "08",
  REVERT_DEPLOYMENT_APPROVAL_PENDING = "09",
  REVERT_DEPLOYMENT_PENDING = "10",
  REVERT_DEPLOYING = "11",
  REVERT_WAITING_FOR_RETRY = "12",
  REVERT_DEPLOYMENT_FAILED = "13",
  CANCELLED = "14",
}
/**
 * TcktStsTypeCpntPrjPrgrs is the definition of tckt_sts_type_cpnt_prj_prgrs.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeCpntPrjPrgrs {
  COMPONENT_PROJECT_REQUIREMENT_DESIGN = "01",
  COMPONENT_PROJECT_IN_PROGRESS = "02",
  COMPONENT_PROJECT_COMPLETE = "03",
}
/**
 * TcktStsTypeCpntDsgn is the definition of tckt_sts_type_cpnt_dsgn.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeCpntDsgn {
  WAITING = "01",
  DESIGN = "02",
  DESIGN_REVIEW = "03",
  DESIGN_APPROVED = "04",
  CANCELLED = "05",
}
/**
 * TcktStsTypeCpntStgDplymnt is the definition of tckt_sts_type_cpnt_stg_dplymnt.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeCpntStgDplymnt {
  WAITING = "01",
  REQUEST_PLANNING = "02",
  DEPLOYMENT_APPROVAL_PENDING = "03",
  DEPLOYMENT_PENDING = "04",
  DEPLOYING = "05",
  WAITING_FOR_RETRY = "06",
  DEPLOYED = "07",
  DEPLOYMENT_FAILED = "08",
  REVERT_DEPLOYMENT_APPROVAL_PENDING = "09",
  REVERT_DEPLOYMENT_PENDING = "10",
  REVERT_DEPLOYING = "11",
  REVERT_WAITING_FOR_RETRY = "12",
  REVERT_DEPLOYMENT_FAILED = "13",
  CANCELLED = "14",
}
/**
 * TcktStsTypeCpntPrdDplymnt is the definition of tckt_sts_type_cpnt_prd_dplymnt.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeCpntPrdDplymnt {
  WAITING = "01",
  REQUEST_PLANNING = "02",
  DEPLOYMENT_APPROVAL_PENDING = "03",
  DEPLOYMENT_PENDING = "04",
  DEPLOYING = "05",
  WAITING_FOR_RETRY = "06",
  DEPLOYED = "07",
  DEPLOYMENT_FAILED = "08",
  REVERT_DEPLOYMENT_APPROVAL_PENDING = "09",
  REVERT_DEPLOYMENT_PENDING = "10",
  REVERT_DEPLOYING = "11",
  REVERT_WAITING_FOR_RETRY = "12",
  REVERT_DEPLOYMENT_FAILED = "13",
  CANCELLED = "14",
}
/**
 * TcktStsTypeCpntStgStupTask is the definition of tckt_sts_type_cpnt_stg_stup_task.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeCpntStgStupTask {
  WAITING = "01",
  IN_PROGRESS = "02",
  COMPLETE = "03",
  CANCELLED = "04",
}
/**
 * TcktStsTypeCpntOtherStgStupTask is the definition of tckt_sts_type_cpnt_other_stg_stup_task.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeCpntOtherStgStupTask {
  WAITING = "01",
  IN_PROGRESS = "02",
  COMPLETE = "03",
  CANCELLED = "04",
}
/**
 * TcktStsTypeCpntPrdStupTask is the definition of tckt_sts_type_cpnt_prd_stup_task.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TcktStsTypeCpntPrdStupTask {
  WAITING = "01",
  IN_PROGRESS = "02",
  COMPLETE = "03",
  CANCELLED = "04",
}
/**
 * TlndClstrUpdateType is the definition of tlnd_clstr_update_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TlndClstrUpdateType {
  DO_NOT_USE = "1",
  NEW_CREATION = "2",
  RESIZING = "3",
  DIVERSION = "4",
}
/**
 * TrnsmsnType is the definition of trnsmsn_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TrnsmsnType {
  TRANSMISSION_IS_ONLY_INSIDE_FR = "OnlyInside",
  TRANSMISSION_BELONG_TO_OUTSIDE_FR = "BelongToOutside",
}
/**
 * TstUseFlg is the definition of tst_use_flg.
 * It is used for the validation comparing with the value from general code master.
 */
export enum TstUseFlg {
  USE_STAGING_ENVIRONMENT = "AlwaysOnEnvOnly",
  NEED_AN_ADDITIONAL_TEST_ENVIRONMENT = "SpecialEnvRequired",
}
/**
 * PjtBdgtAcqstnReqType is the definition of pjt_bdgt_acqstn_req_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum PjtBdgtAcqstnReqType {
  REQUIRED = "Required",
  NO_REQUIRED_IE_TEAM_MANAGED = "NoRequired",
}
/**
 * DataUnitType is the definition of data_unit_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DataUnitType {
  GLOBAL_BUSINESS_UNIT = "1",
  ITEM_BRAND = "2",
  COUNTRY = "3",
  BUSINESS_UNIT = "4",
  AIM_BATCH_REGION = "5",
  TIME_ZONE = "6",
  FR_COMPANY = "7",
}
/**
 * LayoutDerivationReasonType is the definition of layout_derivation_reason_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum LayoutDerivationReasonType {
  EDH_CONVERTER = "1",
  EDI_CONVERTER_COMPLETE_XML = "2",
  EDI_CONVERTER_XML_CSV = "3",
  EDI_CONVERTER_XML_CSV_COMBINED = "4",
  EDI_CONVERTER_XML_CSV_SPLITTED = "5",
  EDI_CONVERTER_COMPLETE_CSV = "6",
  ORIGIN = "0",
}
/**
 * InterfaceRequirementType is the definition of interface_requirement_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum InterfaceRequirementType {
  CREATE = "C",
  UPDATE = "U",
  DELETE = "D",
  NO_CHANGE = "R",
}
/**
 * SecurityInformationLevelType is the definition of security_information_level_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum SecurityInformationLevelType {
  CONTAINED_DIRECT_PERSONAL_INFO = "Directory",
  CONTAINED_INDIRECT_PERSONAL_INFO = "Indirectory",
  NOT_CONTAINED = "NotIncluded",
}
/**
 * SecurityContentsType is the definition of security_contents_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum SecurityContentsType {
  MANDATORY = "1",
  OPTIONAL = "2",
  NOT_CONTAINED = "-",
}
/**
 * EncriptionType is the definition of encription_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum EncriptionType {
  KMS = "01",
  PGP_GPG = "02",
  N_A = "04",
  SEED_CBC = "05",
}
/**
 * InDefCommonFlagType is the definition of in_def_common_flag_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum InDefCommonFlagType {
  YES = "Y",
  NO = "N",
}
/**
 * SnapshotIncrementalDeltaType is the definition of snapshot_incremental_delta_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum SnapshotIncrementalDeltaType {
  SNAPSHOT = "01",
  INCREMENTAL = "02",
  DELTA = "03",
}
/**
 * IfCycleType is the definition of if_cycle_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum IfCycleType {
  REALTIME = "01",
  EVERY_X_MINS = "02",
  HOURLY = "03",
  DAILY = "04",
  DAILY_MULTIPLE = "05",
  WEEKLY = "06",
  WEEKLY_MULTIPLE = "07",
  MONTHLY = "08",
  MONTHLY_MULTIPLE = "09",
  QUARTERLY = "10",
  SEMI_ANNUAL = "11",
  ANNUAL = "12",
  MANUAL = "13",
  OTHER = "99",
}
/**
 * DataScopeType is the definition of data_scope_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DataScopeType {
  ALL = "00",
  BUSINESS_UNIT = "01",
  COUNTRY = "02",
  GLOBAL_BU = "03",
  GLOBAL_BU_X_COUNTRY = "04",
  BRAND = "05",
  BRAND_X_COUNTRY = "06",
  STORE = "07",
  WH = "08",
  SHARD = "11",
  BATCH_REGION = "12",
  TIME_ZONE = "13",
  OTHER = "99",
}
/**
 * SendDatalakeType is the definition of send_datalake_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum SendDatalakeType {
  NONE = "NONE",
  DLK = "DLK",
  SLKTKY = "SLKTKY",
  SLKVIR = "SLKVIR",
  SLKMUM = "SLKMUM",
  SLKFRK = "SLKFRK",
  SLKSGP = "SLKSGP",
  SLKSEL = "SLKSEL",
  SLKSHA = "SLKSHA",
  DLKNDR = "DLKNDR",
}
/**
 * EtlJobType is the definition of etl_job_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum EtlJobType {
  TRANSCEIVER = "Transceiver",
  CONVERTER = "Converter",
}
/**
 * InterruptType is the definition of interrupt_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum InterruptType {
  NONE = "None",
  CANCEL = "Cancel",
  PENDING = "Pending",
  NOCHANGE = "NoChange",
}
/**
 * SrcDstTypeCd is the definition of src_dst_type_cd.
 * It is used for the validation comparing with the value from general code master.
 */
export enum SrcDstTypeCd {
  INTERDOMAIN_SOURCE = "1",
  INTERDOMAIN_DESTINATION = "2",
  DIP_INTERNAL_SOURCE = "3",
  DIP_INTERNAL_DESTINATION = "4",
}
/**
 * IfItmGrpPhysclName is the definition of if_itm_grp_physcl_name.
 * It is used for the validation comparing with the value from general code master.
 */
export enum IfItmGrpPhysclName {
  INTERFACEDEFINITION = "interfaceDefinition",
  INBOUND = "inbound",
  OUTBOUND = "outbound",
  INBOUND_PARTNER = "inboundPartner",
  OUTBOUND_PARTNER = "outboundPartner",
  PIIDB = "piidb",
  SLK = "slk",
  DLK = "dlk",
  INBOUND_NOTIFICATION = "inboundNotification",
  OUTBOUND_NOTIFICATION = "outboundNotification",
  INBOUND_SECURITY = "inboundSecurity",
  OUTBOUND_SECURITY = "outboundSecurity",
  INBOUND_META = "inboundMeta",
  OUTBOUND_META = "outboundMeta",
  INBOUND_CONVERTER = "inboundConverter",
  OUTBOUND_CONVERTER = "outboundConverter",
  INBOUND_TRANSCEIVER = "inboundTransceiver",
  OUTBOUND_TRANSCEIVER = "outboundTransceiver",
}
/**
 * IfItmPhysclName is the definition of if_itm_physcl_name.
 * It is used for the validation comparing with the value from general code master.
 */
export enum IfItmPhysclName {
  INTERFACE_REQUIREMENT_TYPE = "interfaceRequirementType",
  INTERFACE_ID = "interfaceId",
  INTERFACE_NAME_JAPANESE = "interfaceNameJapanese",
  INTERFACE_NAME_ENGLISH = "interfaceNameEnglish",
  DIP_BY_REGION = "dipByRegion",
  DATA_KIND_ID = "dataKindId",
  INBOUND_ID = "inboundId",
  INBOUND_ID_MANDATORY_PART = "inboundIdMandatoryPart",
  INBOUND_ID_OPTIONAL_PART = "inboundIdOptionalPart",
  OUTBOUND_ID = "outboundId",
  OUTBOUND_ID_MANDATORY_PART = "outboundIdMandatoryPart",
  OUTBOUND_ID_OPTIONAL_PART = "outboundIdOptionalPart",
  COMPONENT_ID = "componentId",
  PARTNER_CODE = "partnerCode",
  PARTNER_NAME = "partnerName",
  PARTNER_BUSINESS = "partnerBusiness",
  CHAIN_TYPE_CODE = "chainTypeCode",
  FILE_TYPE_CODE = "fileTypeCode",
  PARTNER_TYPE = "partnerType",
  CONTENTS_ACCESSIBLE_FLAG = "contentsAccessibleFlag",
  WORK_FILE_RETENTION_DAYS = "workFileRetentionDays",
  RETENTION_PERIOD_VALUE = "retentionPeriodValue",
  PROTOCOL = "protocol",
  OUTPUT_FILE_PREFIX_STG = "outputFilePrefixStg",
  OUTPUT_FILE_PREFIX_PRD = "outputFilePrefixPrd",
  OUTPUT_FILE_BODY_STG = "outputFileBodyStg",
  OUTPUT_FILE_BODY_PRD = "outputFileBodyPrd",
  FILE_EXTENSION = "fileExtension",
  NOTIFICATION_TYPE = "notificationType",
  NOTIFY_FLAG = "notifyFlag",
  NOTIFICATION_CONFIG = "notificationConfig",
  FOLLOWING_ID = "followingId",
  SSH_NOTIFICATION_CONFIG = "sshNotificationConfig",
  KAFKA_NOTIFICATION_CONFIG = "kafkaNotificationConfig",
  SEND_DATALAKE_TYPE = "sendDatalakeType",
  DIFFERENT_LAYOUTS_FOR_INPUT_AND_OUTPUT = "differentLayoutsForInputAndOutput",
  FILE_ID = "fileId",
  TABLE_ID = "tableId",
  BASE_FILE_ID = "baseFileId",
  INTERRUPT_TYPE = "interruptType",
  SECURITY_INFORMATION_LEVEL = "securityInformationLevel",
  INBOUND_ENCRYPTION_TYPE_VALUE = "inboundEncryptionTypeValue",
  OUTBOUND_ENCRYPTION_TYPE_VALUE = "outboundEncryptionTypeValue",
  USE_ETL_TRANSCEIVER = "useEtlTransceiver",
  USE_CONVERTER = "useConverter",
  BQDATASETID_STG = "bqDatasetIdStg",
  BQDATASETID_PRD = "bqDatasetIdPrd",
  IF_CYCLE = "ifCycle",
  IF_CYCLE_NOTE = "ifCycleNote",
  NOTIFICATION_PF_ID = "notificationPfId",
  PARTNER_ADDRESS_STG = "partnerAddressStg",
  PARTNER_ADDRESS_PRD = "partnerAddressPrd",
  REMOTE_FILE_ID = "remoteFileId",
  TALEND_PROJECT = "talendProject",
  PARTNER_IF_ID = "partnerIfId",
  RECEIVE_FLG = "receiveFlg",
  SEND_FLG = "sendFlg",
  PARTNER_INIT_FLG = "partnerInitFlg",
  AUTO_RETRY_FLAG = "autoRetryFlg",
}
/**
 * ReferenceModeType is the definition of reference_mode_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum ReferenceModeType {
  ENVIRONMENT_PRD = "prd",
  ENVIRONMENT_STG = "stg",
  ACTIVE_PROJECTS = "project",
}
/**
 * DeploymentDivisionType is the definition of deployment_division_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DeploymentDivisionType {
  IMMEDIATELY_DEPLOY = "1",
  SCHEDULE_DEPLOY = "2",
}
/**
 * ReviewActionType is the definition of review_action_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum ReviewActionType {
  APPROVE = "1",
  REJECT = "2",
  DISMISS_APPROVAL = "3",
}
/**
 * DeploymentDivisionCode is the definition of deployment_division_code.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DeploymentDivisionCode {
  NORMAL = "1",
  REVERT = "2",
  NONAME_DATAKIND_NAME = "3",
  NONAME_PARTNER_NAME = "4",
  NONAME_COMPONENT_NAME = "5",
}
/**
 * DeploymentRequestResultDivisionCode is the definition of deployment_request_result_division_code.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DeploymentRequestResultDivisionCode {
  DEPLOYED = "1",
  DISCARD = "2",
  REJECT = "3",
}
/**
 * DeploymentRequestProcessingDivisionType is the definition of deployment_request_processing_division_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DeploymentRequestProcessingDivisionType {
  WITHDRAW = "01",
  APPROVE = "02",
  REJECT = "03",
  DISCARD = "04",
  REVERT = "05",
  RETRY = "06",
}
/**
 * DeploymentRequestScreenProcessingDivisionType is the definition of deployment_request_screen_processing_division_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DeploymentRequestScreenProcessingDivisionType {
  NORMAL_MODE = "01",
  BEFORE_APPROVE_MODE = "02",
  REVIEW_MODE = "03",
  WITHDRAW_MODE = "04",
  RETRY_MODE = "05",
  REVERT_MODE = "06",
}
/**
 * NonamePrjType is the definition of noname_prj_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum NonamePrjType {
  DATA_KIND_NAME = "01",
  PARTNER_NAME = "02",
  COMPONENT_NAME = "03",
}
/**
 * DeploymentRequestType is the definition of deployment_request_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DeploymentRequestType {
  INTERFACE = "01",
  COMPONENT = "02",
}
/**
 * CpntPjtType is the definition of cpnt_pjt_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum CpntPjtType {
  EDH = "EDH",
  NOTIFICATOR = "NOTIFICATOR",
  EDI = "EDI",
}
/**
 * CpntPrtclCtgryType is the definition of cpnt_prtcl_ctgry_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum CpntPrtclCtgryType {
  EDH_PROTOCOL = "EDH_PRTCL",
  ETL_SETUP = "ETL_SETUP",
  IF_START_METHOD = "IF_START_METHOD",
  EDI_CHAIN_TYPE = "EDI_CHAIN_TYPE",
  EDH_NOTIFICATION_TYPE = "EDH_NOTIFICATION_TYPE",
}
/**
 * FileExtensionType is the definition of file_extension_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum FileExtensionType {
  ZIP = "zip",
  GZ = "gz",
  CSV = "csv",
  GPG = "gpg",
  XML = "xml",
  JSON = "json",
  NDJSON = "ndjson",
  DAT = "dat",
  Z = "Z",
  DAT_TZ_CTT = "DAT<TZ:CTT>",
  CTRL = "ctrl",
  ZIP_TZ_CTT = "zip<TZ:CTT>",
  GPG_TZ_CTT = "gpg<TZ:CTT>",
  GPG_TZ_EST = "gpg<TZ:EST>",
  GPG_TZ_JST = "gpg<TZ:JST>",
  CSV_TZ_CTT = "csv<TZ:CTT>",
  TSV = "tsv",
  PGP = "pgp",
  SAT = "sat",
  SAT_TZ_CTT = "sat<TZ:CTT>",
  XLSX = "xlsx",
  ZIP_GPG = "zip.gpg",
  CSV_ZIP = "csv.zip",
  CSV_GZ = "csv.gz",
  CSV_GPG = "csv.gpg",
  CSV_PGP = "csv.pgp",
  GPG_ZIP = "gpg.zip",
  JSON_GZ = "json.gz",
  JSON_GPG = "json.gpg",
  NDJSON_GZ = "ndjson.gz",
  TSV_ZIP = "tsv.zip",
  TSV_GPG = "tsv.gpg",
  CSV_GZ_GPG = "csv.gz.gpg",
  CSV_GZ_CTRL = "csv.gz.ctrl",
  CSV_GZ_GPG_CTRL = "csv.gz.gpg.ctrl",
  JSON_GZ_GPG = "json.gz.gpg",
  TAR_Z = "tar.Z",
}
/**
 * RoleClssfctnType is the definition of role_clssfctn_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum RoleClssfctnType {
  LOGINUSERROLE = "01",
  DIPROLE = "02",
  PROJECTROLE = "03",
}
/**
 * RoleCvrgType is the definition of role_cvrg_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum RoleCvrgType {
  JEDI = "JEDI",
  DIP = "DIP",
  PROJECT = "PROJECT",
  ROOT_COMPONENT = "ROOT_COMPONENT",
}
/**
 * DowType is the definition of dow_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DowType {
  SUNDAY = "SUN",
  MONDAY = "MON",
  TUESDAY = "TUE",
  WEDNESDAY = "WED",
  THURSDAY = "THU",
  FRIDAY = "FRI",
  SATURDAY = "SAT",
}
/**
 * NtcDstType is the definition of ntc_dst_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum NtcDstType {
  SRC = "1",
  DST = "2",
  DELEGATE = "3",
  OTHER_COMPONENT = "4",
  CONFLICT_PROJECT = "5",
  UNCLASSIFIED = "6",
}
/**
 * NtcDstPstnType is the definition of ntc_dst_pstn_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum NtcDstPstnType {
  MAIN = "1",
  SUB = "2",
  BOTH = "3",
  DELEGATE = "4",
}
/**
 * SndType is the definition of snd_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum SndType {
  TO = "TO",
  CC = "CC",
}
/**
 * StatsOfAgreementOnBudgetaryType is the definition of stats_of_agreement_on_budgetary_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum StatsOfAgreementOnBudgetaryType {
  AGREED = "Agreed",
  NOT_AGREED = "NotAgreed",
}
/**
 * PjtLnchType is the definition of pjt_lnch_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum PjtLnchType {
  REGULAR = "Regular",
  GOD = "God",
  NONAME = "Noname",
}
/**
 * ChnTypeGrpType is the definition of chn_type_grp_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum ChnTypeGrpType {
  BUCKET_S3_COS = "1_Bucket",
  SFTP = "2_SFTP",
  AS2 = "3_AS2",
  TCP_IP_HTTPS = "4_TCPIP",
}
/**
 * PjtType is the definition of pjt_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum PjtType {
  INTERFACE = "IF",
  COMPONENT = "CPNT",
}
/**
 * RoleType is the definition of role_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum RoleType {
  DIP_MANAGER = "1001",
  DIP_APPROVER = "1002",
  PIC_OF_DIP_APP = "1003",
  PIC_OF_DIP_INFRA = "1004",
  GOD = "1005",
  PIC_OF_IF_RD = "2001",
  PROJECT_OWNER = "2002",
  PROJECT_APPROVER = "2003",
  PIC_OF_COMPONENT_APP = "2004",
  PIC_OF_COMPONENT_INFRA = "2005",
  SYSTEM = "9999",
}
/**
 * SnpshtTblMpngType is the definition of snpsht_tbl_mpng_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum SnpshtTblMpngType {
  IFID = "ifid",
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}
/**
 * DsplyType is the definition of dsply_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DsplyType {
  DISPLAY = "1",
  DISABLE = "2",
  HIDE = "3",
}
/**
 * EtlType is the definition of etl_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum EtlType {
  TALEND = "Talend",
}
/**
 * EdiPollingAdaptorType is the definition of edi_polling_adaptor_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum EdiPollingAdaptorType {
  DO_NOT_USE = "NotUse",
  RFID_ADAPTOR = "RFID",
  SFTP_POLLING_ADAPTOR = "SFTP",
}
/**
 * IfReqCnclType is the definition of if_req_cncl_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum IfReqCnclType {
  CANCEL = "Cancel",
  PURGE = "Purge",
  NORMAL = "Normal",
}
/**
 * IfDfnCnvRuleType is the definition of if_dfn_cnv_rule_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum IfDfnCnvRuleType {
  REPLACE = "Replace",
  PREFIX = "Prefix",
}
/**
 * CpntAttrCnvRuleType is the definition of cpnt_attr_cnv_rule_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum CpntAttrCnvRuleType {
  REPLACE = "Replace",
  FIX = "Fix",
  NOCHANGE = "NoChange",
}
/**
 * EnvCopyDeploymentRequestResultDivisionCode is the definition of env_copy_deployment_request_result_division_code.
 * It is used for the validation comparing with the value from general code master.
 */
export enum EnvCopyDeploymentRequestResultDivisionCode {
  DEPLOYMENT_PENDING = "1",
  DEPLOYING = "2",
  COPY_SUCCESS = "3",
  COPY_FAILED = "4",
  CANCEL = "5",
}
/**
 * DipRgnIdntfrType is the definition of dip_rgn_idntfr_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum DipRgnIdntfrType {
  JP_REGION = "0",
  US_REGION = "1",
  SG_REGION = "2",
  EU_REGION = "3",
  IN_REGION = "4",
  CN_REGION = "5",
}
/**
 * ValidationTypeCode is the definition of validation_type_code.
 * It is used for the validation comparing with the value from general code master.
 */
export enum ValidationTypeCode {
  TEMPORARY_SAVE = "1",
  FINALIZE_REQUIREMENTS_PRJ_PLAN_SCREEN = "2",
  GOD_SAVE = "3",
  IF_ATTR_REVIEW_REQUEST_IFLIST_SCREEN = "4",
}
/**
 * RetentionPeriodDaysType is the definition of retention_period_days_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum RetentionPeriodDaysType {
  DAY_NA = "定めなし",
  DAY_1 = "1日",
  DAY_2 = "2日",
  DAY_3 = "3日",
  DAY_4 = "4日",
  DAY_5 = "5日",
  DAY_6 = "6日",
  DAY_7 = "7日",
  DAY_8 = "8日",
  DAY_9 = "9日",
  DAY_10 = "10日",
  DAY_11 = "11日",
  DAY_12 = "12日",
  DAY_13 = "13日",
  DAY_14 = "14日",
  DAY_15 = "15日",
  DAY_16 = "16日",
  DAY_17 = "17日",
  DAY_18 = "18日",
  DAY_19 = "19日",
  DAY_20 = "20日",
  DAY_21 = "21日",
  DAY_22 = "22日",
  DAY_23 = "23日",
  DAY_24 = "24日",
  DAY_25 = "25日",
  DAY_26 = "26日",
  DAY_27 = "27日",
  DAY_28 = "28日",
  DAY_29 = "29日",
  DAY_30 = "30日",
  DAY_31 = "31日",
  DAY_32 = "32日",
  DAY_33 = "33日",
  DAY_34 = "34日",
  DAY_35 = "35日",
  DAY_36 = "36日",
  DAY_37 = "37日",
  DAY_38 = "38日",
  DAY_39 = "39日",
  DAY_40 = "40日",
  DAY_41 = "41日",
  DAY_42 = "42日",
  DAY_43 = "43日",
  DAY_44 = "44日",
  DAY_45 = "45日",
  DAY_46 = "46日",
  DAY_47 = "47日",
  DAY_48 = "48日",
  DAY_49 = "49日",
  DAY_50 = "50日",
  DAY_51 = "51日",
  DAY_52 = "52日",
  DAY_53 = "53日",
  DAY_54 = "54日",
  DAY_55 = "55日",
  DAY_56 = "56日",
  DAY_57 = "57日",
  DAY_58 = "58日",
  DAY_59 = "59日",
  DAY_60 = "60日",
  DAY_61 = "61日",
  DAY_62 = "62日",
  DAY_63 = "63日",
  DAY_64 = "64日",
  DAY_65 = "65日",
  DAY_66 = "66日",
  DAY_67 = "67日",
  DAY_68 = "68日",
  DAY_69 = "69日",
  DAY_70 = "70日",
  DAY_71 = "71日",
  DAY_72 = "72日",
  DAY_73 = "73日",
  DAY_74 = "74日",
  DAY_75 = "75日",
  DAY_76 = "76日",
  DAY_77 = "77日",
  DAY_78 = "78日",
  DAY_79 = "79日",
  DAY_80 = "80日",
  DAY_81 = "81日",
  DAY_82 = "82日",
  DAY_83 = "83日",
  DAY_84 = "84日",
  DAY_85 = "85日",
  DAY_86 = "86日",
  DAY_87 = "87日",
  DAY_88 = "88日",
  DAY_89 = "89日",
  DAY_90 = "90日",
  DAY_91 = "91日",
  DAY_92 = "92日",
  DAY_93 = "93日",
  DAY_94 = "94日",
  DAY_95 = "95日",
  DAY_96 = "96日",
  DAY_97 = "97日",
  DAY_98 = "98日",
  DAY_99 = "99日",
  DAY_100 = "100日",
  DAY_101 = "101日",
  DAY_102 = "102日",
  DAY_103 = "103日",
  DAY_104 = "104日",
  DAY_105 = "105日",
  DAY_106 = "106日",
  DAY_107 = "107日",
  DAY_108 = "108日",
  DAY_109 = "109日",
  DAY_110 = "110日",
  DAY_111 = "111日",
  DAY_112 = "112日",
  DAY_113 = "113日",
  DAY_114 = "114日",
  DAY_115 = "115日",
  DAY_116 = "116日",
  DAY_117 = "117日",
  DAY_118 = "118日",
  DAY_119 = "119日",
  DAY_120 = "120日",
  DAY_121 = "121日",
  DAY_122 = "122日",
  DAY_123 = "123日",
  DAY_124 = "124日",
  DAY_125 = "125日",
  DAY_126 = "126日",
  DAY_127 = "127日",
  DAY_128 = "128日",
  DAY_129 = "129日",
  DAY_130 = "130日",
  DAY_131 = "131日",
  DAY_132 = "132日",
  DAY_133 = "133日",
  DAY_134 = "134日",
  DAY_135 = "135日",
  DAY_136 = "136日",
  DAY_137 = "137日",
  DAY_138 = "138日",
  DAY_139 = "139日",
  DAY_140 = "140日",
  DAY_141 = "141日",
  DAY_142 = "142日",
  DAY_143 = "143日",
  DAY_144 = "144日",
  DAY_145 = "145日",
  DAY_146 = "146日",
  DAY_147 = "147日",
  DAY_148 = "148日",
  DAY_149 = "149日",
  DAY_150 = "150日",
  DAY_151 = "151日",
  DAY_152 = "152日",
  DAY_153 = "153日",
  DAY_154 = "154日",
  DAY_155 = "155日",
  DAY_156 = "156日",
  DAY_157 = "157日",
  DAY_158 = "158日",
  DAY_159 = "159日",
  DAY_160 = "160日",
  DAY_161 = "161日",
  DAY_162 = "162日",
  DAY_163 = "163日",
  DAY_164 = "164日",
  DAY_165 = "165日",
  DAY_166 = "166日",
  DAY_167 = "167日",
  DAY_168 = "168日",
  DAY_169 = "169日",
  DAY_170 = "170日",
  DAY_171 = "171日",
  DAY_172 = "172日",
  DAY_173 = "173日",
  DAY_174 = "174日",
  DAY_175 = "175日",
  DAY_176 = "176日",
  DAY_177 = "177日",
  DAY_178 = "178日",
  DAY_179 = "179日",
  DAY_180 = "180日",
  DAY_181 = "181日",
  DAY_182 = "182日",
  DAY_183 = "183日",
  DAY_184 = "184日",
  DAY_185 = "185日",
  DAY_186 = "186日",
  DAY_187 = "187日",
  DAY_188 = "188日",
  DAY_189 = "189日",
  DAY_190 = "190日",
  DAY_191 = "191日",
  DAY_192 = "192日",
  DAY_193 = "193日",
  DAY_194 = "194日",
  DAY_195 = "195日",
  DAY_196 = "196日",
  DAY_197 = "197日",
  DAY_198 = "198日",
  DAY_199 = "199日",
  DAY_200 = "200日",
  DAY_201 = "201日",
  DAY_202 = "202日",
  DAY_203 = "203日",
  DAY_204 = "204日",
  DAY_205 = "205日",
  DAY_206 = "206日",
  DAY_207 = "207日",
  DAY_208 = "208日",
  DAY_209 = "209日",
  DAY_210 = "210日",
  DAY_211 = "211日",
  DAY_212 = "212日",
  DAY_213 = "213日",
  DAY_214 = "214日",
  DAY_215 = "215日",
  DAY_216 = "216日",
  DAY_217 = "217日",
  DAY_218 = "218日",
  DAY_219 = "219日",
  DAY_220 = "220日",
  DAY_221 = "221日",
  DAY_222 = "222日",
  DAY_223 = "223日",
  DAY_224 = "224日",
  DAY_225 = "225日",
  DAY_226 = "226日",
  DAY_227 = "227日",
  DAY_228 = "228日",
  DAY_229 = "229日",
  DAY_230 = "230日",
  DAY_231 = "231日",
  DAY_232 = "232日",
  DAY_233 = "233日",
  DAY_234 = "234日",
  DAY_235 = "235日",
  DAY_236 = "236日",
  DAY_237 = "237日",
  DAY_238 = "238日",
  DAY_239 = "239日",
  DAY_240 = "240日",
  DAY_241 = "241日",
  DAY_242 = "242日",
  DAY_243 = "243日",
  DAY_244 = "244日",
  DAY_245 = "245日",
  DAY_246 = "246日",
  DAY_247 = "247日",
  DAY_248 = "248日",
  DAY_249 = "249日",
  DAY_250 = "250日",
  DAY_251 = "251日",
  DAY_252 = "252日",
  DAY_253 = "253日",
  DAY_254 = "254日",
  DAY_255 = "255日",
  DAY_256 = "256日",
  DAY_257 = "257日",
  DAY_258 = "258日",
  DAY_259 = "259日",
  DAY_260 = "260日",
  DAY_261 = "261日",
  DAY_262 = "262日",
  DAY_263 = "263日",
  DAY_264 = "264日",
  DAY_265 = "265日",
  DAY_266 = "266日",
  DAY_267 = "267日",
  DAY_268 = "268日",
  DAY_269 = "269日",
  DAY_270 = "270日",
  DAY_271 = "271日",
  DAY_272 = "272日",
  DAY_273 = "273日",
  DAY_274 = "274日",
  DAY_275 = "275日",
  DAY_276 = "276日",
  DAY_277 = "277日",
  DAY_278 = "278日",
  DAY_279 = "279日",
  DAY_280 = "280日",
  DAY_281 = "281日",
  DAY_282 = "282日",
  DAY_283 = "283日",
  DAY_284 = "284日",
  DAY_285 = "285日",
  DAY_286 = "286日",
  DAY_287 = "287日",
  DAY_288 = "288日",
  DAY_289 = "289日",
  DAY_290 = "290日",
  DAY_291 = "291日",
  DAY_292 = "292日",
  DAY_293 = "293日",
  DAY_294 = "294日",
  DAY_295 = "295日",
  DAY_296 = "296日",
  DAY_297 = "297日",
  DAY_298 = "298日",
  DAY_299 = "299日",
  DAY_300 = "300日",
  DAY_301 = "301日",
  DAY_302 = "302日",
  DAY_303 = "303日",
  DAY_304 = "304日",
  DAY_305 = "305日",
  DAY_306 = "306日",
  DAY_307 = "307日",
  DAY_308 = "308日",
  DAY_309 = "309日",
  DAY_310 = "310日",
  DAY_311 = "311日",
  DAY_312 = "312日",
  DAY_313 = "313日",
  DAY_314 = "314日",
  DAY_315 = "315日",
  DAY_316 = "316日",
  DAY_317 = "317日",
  DAY_318 = "318日",
  DAY_319 = "319日",
  DAY_320 = "320日",
  DAY_321 = "321日",
  DAY_322 = "322日",
  DAY_323 = "323日",
  DAY_324 = "324日",
  DAY_325 = "325日",
  DAY_326 = "326日",
  DAY_327 = "327日",
  DAY_328 = "328日",
  DAY_329 = "329日",
  DAY_330 = "330日",
  DAY_331 = "331日",
  DAY_332 = "332日",
  DAY_333 = "333日",
  DAY_334 = "334日",
  DAY_335 = "335日",
  DAY_336 = "336日",
  DAY_337 = "337日",
  DAY_338 = "338日",
  DAY_339 = "339日",
  DAY_340 = "340日",
  DAY_341 = "341日",
  DAY_342 = "342日",
  DAY_343 = "343日",
  DAY_344 = "344日",
  DAY_345 = "345日",
  DAY_346 = "346日",
  DAY_347 = "347日",
  DAY_348 = "348日",
  DAY_349 = "349日",
  DAY_350 = "350日",
  DAY_351 = "351日",
  DAY_352 = "352日",
  DAY_353 = "353日",
  DAY_354 = "354日",
  DAY_355 = "355日",
  DAY_356 = "356日",
  DAY_357 = "357日",
  DAY_358 = "358日",
  DAY_359 = "359日",
  DAY_360 = "360日",
  DAY_361 = "361日",
  DAY_362 = "362日",
  DAY_363 = "363日",
  DAY_364 = "364日",
  DAY_365 = "365日",
}
/**
 * IfCallerScreenType is the definition of if_caller_screen_type.
 * It is used for the validation comparing with the value from general code master.
 */
export enum IfCallerScreenType {
  IF_REQUIREMENT = "1",
  IF_REQUIREMENT_CHANGE = "2",
  IF_LIST_INPUT = "3",
  IF_LIST_REVIEW = "4",
  IF_LIST_GOD = "5",
}
